<mat-card *ngIf="selectedProspect">


    <mat-card-content style="overflow: hidden;">

        <div style="background: url('../../assets/img/morceau/titre.png');height: 60px;
         background-size: 100% 100%; width: 100%;color: #2F4395; font-size: 18px;">

            <div style="float: left;margin-top:5px;">
                <img src="../../assets/img/morceau/1.png" height="40">
                Informations Client
            </div>
            <div style="float: right; cursor: pointer;" (click)="clickedMe()">
                <img src="../../assets/img/morceau/edit.png">
            </div>

        </div>

        <div style=" background: #EEECEC;">

            <div class="titles1">
                <div class="label">
                    Raison Social
                </div>

            
                <div class="label">
                    Pays
                </div>

                <div class="label">
                    NRC
                </div>

                <div class="label">
                    NIF
                </div>

                <div class="label">
                    NAI
                </div>

                <div class="label">
                    VAT Number
                </div>
                <div class="label">
                   Status
                </div>
            </div>



            <div class="content1">

                <div class="labeltext">
                    {{selectedProspect.raisonSocial | uppercase}}
                </div>

       

                <div class="labeltext" *ngIf="!selectedProspect.pays && selectedProspect.paysId">
                    {{selectedProspect.paysId.designationFr | uppercase}}
                </div>
                <div class="labeltext" *ngIf="selectedProspect.pays">
                    {{selectedProspect.pays | uppercase}}
                </div>
                <div class="labeltext">
                    {{selectedProspect.nrc}}
                </div>
                <div class="labeltext">
                    {{selectedProspect.nif}}
                </div>
                <div class="labeltext">
                    {{selectedProspect.nai}}
                </div>
                <div class="labeltext">
                    {{selectedProspect.vatNumber}}
                </div>
                <div class="labeltext">
                   
                    <div     style="display: flex; align-items: center; "  >
                        <div   [ngStyle]="{'background-color': selectedProspect.color}"
                         class="bulle" > </div><div>   {{selectedProspect.status}}</div>  </div>
                </div>

            </div>






        </div>


    </mat-card-content>


</mat-card>